



import { Component, Vue } from "vue-property-decorator";
import { fabric } from "fabric";
import { dataURLtoFile } from "./utils";
import { v4 as uuidv4 } from "uuid";
@Component({
  name: "qSignature",
})
export default class QSignature extends Vue {
  public canvas;

  show(options) {
    this.canvas = new fabric.Canvas(this.$refs.canvas);
    this.canvas.freeDrawingBrush = new fabric.PencilBrush(this.canvas);
    this.canvas.freeDrawingBrush.width = 6;
    this.canvas.isDrawingMode = true;
    this.canvas.setWidth(options.width);
    this.canvas.setHeight(options.height);
  }

  public export() {
    const canvasObjects = this.canvas.toJSON(["groupId", "qType", "areaId"]);
    
    return {
      object: canvasObjects,
      file: dataURLtoFile(this.canvas.toDataURL(), uuidv4() + ".png"),
    };
  }
}
